import React from "react";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled.div`
  flex: 1;
  background-image: url('image/background.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  overflow: hidden;
  font-family: "Poppins", sans-serif;

  @media (max-width: 768px) {
    display: none;
  }
`;

const Content = styled.div`
  z-index: 1;
  padding: 40px;
  animation: ${fadeIn} 0.8s ease-out;
`;

const LogoImage = styled.img`
  max-width: 240px;
  width: 100%;
  height: auto;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.3));
  animation: ${fadeIn} 0.8s ease-out;
  user-select: none;
  pointer-events: none;
`;

function LoginBranding() {
  return (
    <Container>
      <Content>
        <LogoImage src="/image/EssentialOne logo branco 1.png" alt="EssentialOne" />
      </Content>
    </Container>
  );
}

export default LoginBranding;